export const kvkk = {
  routes: [
    {
      path: "/kvkk/survey-template",
      component: () => import("../organization-survey-template"),
    },
    {
      path: "/kvkk/survey/template/:id",
      component: () => import("../organization-survey-view"),
    },
    {
      path: "/kvkk/survey/:id/members",
      component: () => import("../organization-survey-members-view"),
    },
    {
      path: "/kvkk/survey/:id/results",
      component: () => import("../organization-survey-results-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/survey-template",
      component: () => import("../organization-survey-template"),
    },
    {
      path: "/gdpr/survey/template/:id",
      component: () => import("../organization-survey-view"),
    },
    {
      path: "/gdpr/survey/:id/members",
      component: () => import("../organization-survey-members-view"),
    },
    {
      path: "/gdpr/survey/:id/results",
      component: () => import("../organization-survey-results-view"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/survey-template",
      component: () => import("../organization-survey-template"),
    },
    {
      path: "/bgys/survey/template/:id",
      component: () => import("../organization-survey-view"),
    },
    {
      path: "/bgys/survey/:id/members",
      component: () => import("../organization-survey-members-view"),
    },
    {
      path: "/bgys/survey/:id/results",
      component: () => import("../organization-survey-results-view"),
    },
  ],
};
export const ddo = {
  routes: [
    {
      path: "/ddo/survey-template",
      component: () => import("../organization-survey-template"),
    },
    {
      path: "/ddo/survey/template/:id",
      component: () => import("../organization-survey-view"),
    },
    {
      path: "/ddo/survey/:id/members",
      component: () => import("../organization-survey-members-view"),
    },
    {
      path: "/ddo/survey/:id/results",
      component: () => import("../organization-survey-results-view"),
    },
  ],
};
export const organization = {
  routes: [
    {
      path: "/organization/survey-template",
      component: () => import("../organization-survey-template"),
    },
    {
      path: "/organization/survey/template/:id",
      component: () => import("../organization-survey-view"),
    },
    {
      path: "/organization/survey/:id/members",
      component: () => import("../organization-survey-members-view"),
    },
    {
      path: "/organization/survey/:id/results",
      component: () => import("../organization-survey-results-view"),
    },
  ],
};
